@if (logSections()) {
  <div *ngIf="showHeader()" class="flex-table">
    <div class="flex-row tab-header">
      <div class="flex-cell">
        <span data-id="jobslog-log-header">{{ 'jobs.jobLog.for' | translate | interpolate:jobId() }}</span>
      </div>
      <div class="flex-cell header-actions">
        <button data-id="jobslog-log-download" class="btn btn-primary pull-right" (click)="downloadLogs()">
          {{ 'jobs.jobLog.download' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="gear-logs">
    @if (!showAllLines()) {
      <ng-container [ngTemplateOutlet]="logLines" [ngTemplateOutletContext]="{lines: logSections().start}"></ng-container>
      <div class="show-all">{{ 'jobs.jobLog.truncated' | translate }} <a (click)="showAllLines.set(true)">{{ 'jobs.jobLog.showAll' | translate }}</a></div>
      <ng-container [ngTemplateOutlet]="logLines" [ngTemplateOutletContext]="{lines: logSections().end}"></ng-container>
    }
    @if (showAllLines()) {
      @if (logSections().all.length > 4000) {
        <ng-container [ngTemplateOutlet]="logLinesVirtualScroll" [ngTemplateOutletContext]="{lines: logSections().all}"></ng-container>
      } @else {
        <ng-container [ngTemplateOutlet]="logLines" [ngTemplateOutletContext]="{lines: logSections().all}"></ng-container>
      }
    }

    <ng-template #logLines let-lines="lines">
      @for (line of lines; track line) {
        <div class="log-line">
          <ng-container [ngTemplateOutlet]="lineTmpl" [ngTemplateOutletContext]="{line}"></ng-container>
        </div>
      }
    </ng-template>

    <ng-template #logLinesVirtualScroll let-lines="lines">
      <cdk-virtual-scroll-viewport [minBufferPx]="4000" [maxBufferPx]="6000" itemSize="20" class="log-viewport">
        <div *cdkVirtualFor="let line of lines" class="log-line">
          <ng-container [ngTemplateOutlet]="lineTmpl" [ngTemplateOutletContext]="{line}"></ng-container>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-template>

    <ng-template #lineTmpl let-line="line">
      <span class="fd-{{ line.fd }} log-line-span">{{line.msg}}</span>
    </ng-template>
  </div>
} @else {
  Loading...
}



